import _ from 'lodash';
import checkoutValidator from './CheckoutValidator';
import ValidationUtils from './ValidationUtils';
import Messages from './Messages';
import PersonalIdentificationType from '../../model/PersonalIdentificationType';
import FormValidationUtils from '../../components/form/FormValidationUtils';
import EmploymentData from '../../components/checkout/CreditAssessmentStep2/CAOccupation.json';
import FormConfigUtils from '../../components/form/FormConfigUtils';

const ContractCheckoutValidator = (values) => {
  const caRequiredFields = [{
    name: 'creditAssessment.agreeToCreditAssessment',
    errorMessage: '' // this being empty is just customer not agreeing to CA - no need to show error message for this
  }, {
    name: 'creditAssessment.firstName',
    errorMessage: Messages.REQUIRED_FIRST_NAME
  }, {
    name: 'creditAssessment.lastName',
    errorMessage: Messages.REQUIRED_LAST_NAME
  }, {
    name: 'creditAssessment.dateOfBirthDay',
    errorMessage: Messages.REQUIRED_DOB_DAY
  }, {
    name: 'creditAssessment.dateOfBirthMonth',
    errorMessage: Messages.REQUIRED_DOB_MONTH
  }, {
    name: 'creditAssessment.dateOfBirthYear',
    errorMessage: Messages.REQUIRED_DOB_YEAR
  }, {
    name: 'creditAssessment.isNzResidentOrCitizen',
    errorMessage: Messages.REQUIRED_SELECT
  }, {
    name: 'creditAssessment.personalIdentificationType',
    errorMessage: Messages.REQUIRED_SELECT
  }, {
    name: 'creditAssessment.housingStatus',
    errorMessage: Messages.REQUIRED_SELECT
  }, {
    name: 'creditAssessment.occupationStatus',
    errorMessage: Messages.REQUIRED_SELECT
  }, {
    name: 'creditAssessment.currentAddress.addressLine1',
    errorMessage: Messages.REQUIRED_MESSAGE
  }];

  const driverLicenseRequiredFields = [{
    name: 'creditAssessment.nzDriverLicense.licenseNumber',
    errorMessage: Messages.REQUIRED_MESSAGE
  }, {
    name: 'creditAssessment.nzDriverLicense.licenseVersionNumber',
    errorMessage: Messages.REQUIRED_MESSAGE
  }, {
    name: 'creditAssessment.nzDriverLicense.expiryDateDay',
    errorMessage: Messages.REQUIRED_DAY
  }, {
    name: 'creditAssessment.nzDriverLicense.expiryDateMonth',
    errorMessage: Messages.REQUIRED_MONTH
  }, {
    name: 'creditAssessment.nzDriverLicense.expiryDateYear',
    errorMessage: Messages.REQUIRED_YEAR
  }];

  const passportRequiredFields = [{
    name: 'creditAssessment.nzPassport.passportNumber',
    errorMessage: Messages.REQUIRED_MESSAGE
  }, {
    name: 'creditAssessment.nzPassport.expiryDateDay',
    errorMessage: Messages.REQUIRED_DAY
  }, {
    name: 'creditAssessment.nzPassport.expiryDateMonth',
    errorMessage: Messages.REQUIRED_MONTH
  }, {
    name: 'creditAssessment.nzPassport.expiryDateYear',
    errorMessage: Messages.REQUIRED_YEAR
  }];

  let errors = checkoutValidator(values);

  if (values.creditAssessment) {
    FormValidationUtils.addCustomFieldsValidation(
      EmploymentData,
      values.creditAssessment.occupationStatus,
      values.creditAssessment.employmentStatus,
      caRequiredFields
    );
    const subcategories = FormConfigUtils.getSubCategories(EmploymentData, values.creditAssessment.occupationStatus);
    if (subcategories) {
      caRequiredFields.push({
        name: 'creditAssessment.employmentStatus',
        errorMessage: Messages.REQUIRED_SELECT
      });
    }
  }

  errors = _.merge(errors, ValidationUtils.validateRequiredFields(caRequiredFields, values));
  if (values.creditAssessment) {
    errors = _.merge(errors, ValidationUtils.validateOverAge(values, 'creditAssessment', 'dateOfBirth', 18));
    errors = _.merge(errors, ValidationUtils.validateTimeAtAddressFields(values));
  }

  if (values.creditAssessment &&
    values.creditAssessment.personalIdentificationType &&
    values.creditAssessment.personalIdentificationType === PersonalIdentificationType.NZ_PASSPORT) {
    errors = _.merge(
      errors,
      ValidationUtils.validateRequiredFields(passportRequiredFields, values)
    );
    errors = _.merge(errors, ValidationUtils.validateNzPassportNumber(
      values,
      'creditAssessment.nzPassport.passportNumber'));
    errors = _.merge(errors, ValidationUtils.validateFutureDate(
      values,
      'creditAssessment.nzPassport',
      'expiryDate'));
  }

  if (values.creditAssessment &&
    values.creditAssessment.personalIdentificationType &&
    values.creditAssessment.personalIdentificationType === PersonalIdentificationType.NZ_DRIVER_LICENSE) {
    errors = _.merge(
      errors,
      ValidationUtils.validateRequiredFields(driverLicenseRequiredFields, values)
    );
    errors = _.merge(errors, ValidationUtils.validateNzDriverLicenseNumber(
      values,
      'creditAssessment.nzDriverLicense.licenseNumber'));
    errors = _.merge(errors, ValidationUtils.validateFutureDate(
      values, 'creditAssessment.nzDriverLicense',
      'expiryDate'));
  }

  if (values.creditAssessment &&
    values.creditAssessment.occupationStatus) {
    const customFields = FormConfigUtils.getCustomFieldsInCategory(
      EmploymentData,
      values.creditAssessment.occupationStatus);

    for (const field of customFields) {
      if (field.fieldType === 'month-year' && (field.isRequired || field.required)) {
        const path = field.name.split('.');
        errors = _.merge(errors, ValidationUtils.validatePastMonthYear(values, path[0], path[1]));
      }
      if (field.fieldType === 'month-year' && FormValidationUtils.hasValueMonthDay(values, field.name)) {
        const path = field.name.split('.');
        errors = _.merge(errors, ValidationUtils.validatePastMonthYear(values, path[0], path[1]));
      }
    }
  }
  return errors;
};

export default ContractCheckoutValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/ContractCheckoutValidator.js
 **/